module.exports = __webpack_public_path__ + "img/share_icon.5edb82b1.png";